import React, {useEffect, useState, useRef} from 'react'
import PropTypes from 'prop-types'
import {useSelector, useDispatch} from "react-redux"

import {CommonError} from "../../componets/errors";
import {Box, Button, Chip, CircularProgress, Typography} from '@material-ui/core'

import * as rules from '../../constants/rules'
import * as messages from '../../constants/messages'

import useStyles from './styles'

import {selectors as applicationSelectors} from "../application/duck"
import {selectors as configSelectors} from "../config/duck"
import {actions as applicationActions} from "../application/duck"

import schema from './schema'
import {createHashHistory} from 'history';
import {File} from "../../componets/fields";

const history = createHashHistory({
    basename: '',
    hashType: 'noslash',
});

const Terms = ({onNext, onBack, id, step, name}) => {
    const classes = useStyles();

    const config = useSelector(configSelectors.configItem);
    const application = useSelector(applicationSelectors.applicationItem);
    const applicationId = useSelector(applicationSelectors.applicationId);
    const applicationErrors = useSelector(applicationSelectors.applicationErrors);
    const dispatch = useDispatch();

    const initialMount = useRef(true);
    const [updating, setUpdating] = useState(false);
    const [uploading, setUploading] = useState(false);

    const [form, setForm] = useState(null);
    const [errors, setErrors] = useState(null);
    const [initiallySubmitted, setInitiallySubmitted] = useState(false);
    const [valid, setValid] = useState(false);

    useEffect(() => {
        const nextStep = application && application.nextStepId ? application.nextStepId : 0;
        if (nextStep < step) history.push(config.steps[nextStep].url);

        let initialValues = {};
        let initialErrors = {};

        Object.keys(schema).forEach((key, index) => {
            initialValues[key] = {value: schema[key].initialValue || "", name: schema[key].label, index};
            initialErrors[key] = "";
        });
        if (application && application.data[id]) {
            setForm(application.data[id]);
        } else {
            setForm({
                name: name, values: {
                    ...initialValues
                }
            });
        }
        setErrors(initialErrors);
    }, []);

    useEffect(() => {
        if (applicationErrors.length > 0) {
            setUpdating(false);
            window.scrollTo(0, 0);
        }
    }, [applicationErrors]);

    useEffect(() => {
        let err = {};
        let noErrors = true;

        if (form) {
            for (let key in schema) {
                if (schema[key].required === "true" &&
                    ((typeof form.values[key].value === 'string' && form.values[key].value.trim() === "") || form.values[key].value.length === 0)) {
                    err[key] = messages['required'];
                    noErrors = false;
                } else if (schema[key].rules && !rules[schema[key].rules].isValidSync(form.values[key].value)) {
                    noErrors = false;
                    err[key] = messages[schema[key].rules];
                } else {
                    err[key] = "";
                }
            }
            setValid(noErrors);
        }

        if (initiallySubmitted) {
            setErrors({...errors, ...err});
        }
    }, [form, initiallySubmitted]);

    useEffect(() => {
        if (initialMount.current) {
            initialMount.current = false;
        } else {
            setUpdating(false);
            onNext();
        }
    }, [application]);

    const handleSubmit = () => {
        if (!initiallySubmitted) setInitiallySubmitted(true);


        if (valid) {
            setUpdating(true);

            dispatch(applicationActions.updateApplicationData({
                id: applicationId,
                data: {
                    value: form,
                },
                key: id,
                step: step
            }));
        } else {
            window.scrollTo(0, 0);
        }
    };

    const handleChange = (key, value) => {
        setForm({...form, values: {...form.values, [key]: {...form.values[key], value: value}}});
    };

    return (
        <Box>
            {applicationErrors.length > 0 && <CommonError/>}

            {form && <form>
                <File onChange={handleChange}
                      disableForm={() => {setUploading(true)}}
                      enableForm={() => {setUploading(false)}}
                      disabled={updating}
                      errorMessage={errors['photoId']}
                      id="photoId"
                      label={schema.photoId.label}

                      placeholder={schema.photoId.placeholder}
                      required={schema.photoId.required}/>
            </form>}
            <br/>
            {form?.values.photoId.value && <Typography variant="body2">
                Uploaded file name:&nbsp;&nbsp;<Chip label={form.values.photoId.value.split('/').slice(-1)} variant="outlined" />
            </Typography>}

            <Box className={classes.controls}>
                {step > 0 &&
                <Button disabled={updating || uploading} className={`${classes.button} ${classes.backButton}`} variant="outlined"
                        onClick={onBack}>
                    Back
                </Button>}
                <Button disabled={updating || uploading} className={classes.button} variant="contained" onClick={handleSubmit}
                        color="primary">
                    {(updating || uploading) ?
                        <>&nbsp;<CircularProgress color="inherit" size={16}/>&nbsp;&nbsp;Sending...</> :
                        <>Next</>}
                </Button>
            </Box>
        </Box>
    );
};

Terms.propTypes = {
    onNext: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
};

export default Terms;